var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSchoolHat = function SvgSchoolHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.384 3.449A4.2 4.2 0 0 0 10.5 3a4.2 4.2 0 0 0-1.884.449L2.928 6.266c-.914.452-1.153 1.73-.716 2.613v4.448c0 .178.068.35.187.476a.62.62 0 0 0 .45.197.62.62 0 0 0 .452-.197.7.7 0 0 0 .186-.477V9.89l5.129 2.54a4.2 4.2 0 0 0 1.884.448 4.2 4.2 0 0 0 1.884-.449l5.688-2.817c1.237-.612 1.237-2.733 0-3.345l-5.687-2.817"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11v3.212c0 .873.431 1.69 1.187 2.113C6.447 17.03 8.461 18 10 18c1.54 0 3.554-.97 4.813-1.674.756-.424 1.187-1.241 1.187-2.113V11l-3.554 1.683a5.67 5.67 0 0 1-4.892 0z"
  })));
};
export default SvgSchoolHat;